import { Component, OnInit, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FrameworkUtilityComponent } from '../../form-utlity/framework-utility';
import { I18nService } from 'src/app/service/i18n.service';
import { UtilService } from 'src/app/service/util.service';
import * as CONSTANTS from '../../constants';
import { EnvironmentConfig } from '../../../environments/environmentConfig';
import { FormBuilder, Validators } from '@angular/forms';
import { ValidateApartment, ValidateCity, ValidateStreet } from '../validators/personalInfo-address.validator';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
declare var $: any;
declare var google: any;

@Component({
  selector: 'personal-information-address',
  templateUrl: './personal-information-address.component.html',
  styleUrls: ['./personal-information-address.component.less'],
  providers: [FrameworkUtilityComponent, EnvironmentConfig]
})
export class personalInformationAddressComponent implements OnInit {
  currentLang: string;
  enumData: any;
  currentRoutePath: string;
  productFlow: string;
  preQualObj: any;
  partialStatus = [39602, 39603, 39604, 39605, 39607, 39608]
  addressObject: { addresses: any; };
  loader: boolean = false;
  nextProgressPercent: CONSTANTS.PROGRESS_PERCENTAGE;
  addressForm: any;
  responseAddress: any;
  addressSuggestionResponse: any;
  coapplicantAddressForm: any;
  provinceOptions: any = [];
  showAddressPopup: boolean = false;
  addressArrayRequestBody: any = [];
  submitted: boolean = false;
  coSubmitted: boolean = false;
  colorPostal: boolean = false;
  selCode: boolean = false;
  coapplicantSelCode: boolean = false;
  autocomplete: google.maps.places.Autocomplete;
  coapplicantAutocomplete: google.maps.places.Autocomplete;
  address1Field: HTMLInputElement;
  coapplicantAddress1Field: HTMLInputElement;
  address2Field: HTMLInputElement;
  coapplicantAddress2Field: HTMLInputElement;
  postalField: HTMLInputElement;
  coapplicantPostalField: HTMLInputElement;
  cityColor: boolean = true
  provinceColor: boolean = true
  postalColor: boolean = true
  streetColor: boolean = true
  apartmentColor: boolean = true
  coapplicantCityColor: boolean = true
  coapplicantProvinceColor: boolean = true
  coapplicantPostalColor: boolean = true
  coapplicantStreetColor: boolean = true
  coapplicantApartmentColor: boolean = true
  lang: boolean;
  isIos: boolean;
  apartmentApp: boolean = false;
  apartmentCoapp: boolean = false;
  applicantUserObj: any;
  coApplicantUserObj: any;
  checkBoxValue: boolean = false;
  isCoapplicantApplied: boolean;
  isExistingCustomer: boolean;
  areBothCibcCustomer: boolean;
  cleansData: any;
  apiCertificate: any;
  autocompleteInitailise: boolean = false;
  autocompleteInitailiseCoapplicant: boolean = false;
  invalidCount: number = 0;
  invalidAddressApplicant: boolean = false;
  invalidAddressCoapplicant: boolean = false;

  prequalType = 'P';
  switchType = 'S';

  constructor(private el: ElementRef, private fb: FormBuilder, private util: UtilService, private modalService: NgbModal, private _activatedRoute: ActivatedRoute,
    private i18nService: I18nService, private formUtiObj: FrameworkUtilityComponent, private router: Router) {

    this.isIos = !!navigator.platform && /iPad|Mac|iPhone|iPod/.test(navigator.platform);
    this.addressForm = this.fb.group({
      streetName: ['', [Validators.required, ValidateStreet]],
      apartment: ['', [ValidateApartment]],
      city: ['', [Validators.required, ValidateCity]],
      province: ['', Validators.required],
      postalCode: ['', [Validators.required, Validators.pattern('[ABCEGHJKLMNPRSTVXY][0-9][ABCEGHJKLMNPRSTVWXYZ] ?[0-9][ABCEGHJKLMNPRSTVWXYZ][0-9]')]]
    })

    this.coapplicantAddressForm = this.fb.group({
      streetName: ['', [Validators.required, ValidateStreet]],
      apartment: ['', [ValidateApartment]],
      city: ['', [Validators.required, ValidateCity]],
      province: ['', Validators.required],
      postalCode: ['', [Validators.required, Validators.pattern('[ABCEGHJKLMNPRSTVXY][0-9][ABCEGHJKLMNPRSTVWXYZ] ?[0-9][ABCEGHJKLMNPRSTVWXYZ][0-9]')]]
    })

    this.addressForm.get("streetName").valueChanges.subscribe(x => {
      this.address1Field = document.getElementById("streetName") as HTMLInputElement;
      this.invalidAddressApplicant = false;
    })

    this.coapplicantAddressForm.get("streetName").valueChanges.subscribe(x => {
      this.coapplicantAddress1Field = document.getElementById("coApplicantStreetName") as HTMLInputElement
    })


    this.provinceOptions = [
      { code: "AB", nameEn: "Alberta", nameFr: "Alberta" },
      { code: "BC", nameEn: "British Columbia", nameFr: "Colombie-Britannique" },
      { code: "MB", nameEn: "Manitoba", nameFr: "Manitoba" },
      { code: "NB", nameEn: "New Brunswick", nameFr: "Nouveau-Brunswick" },
      { code: "NL", nameEn: "Newfoundland/Labrador", nameFr: "Terre-Neuve-et-Labrador" },
      { code: "NS", nameEn: "Nova Scotia", nameFr: "Nouvelle-Écosse" },
      { code: "NT", nameEn: "Northwest Territories", nameFr: "Territoires du Nord-Ouest" },
      { code: "NU", nameEn: "Nunavut", nameFr: "Nunavut" },
      { code: "ON", nameEn: "Ontario", nameFr: "Ontario" },
      { code: "PE", nameEn: "Prince Edward Island", nameFr: "Île-du-Prince-Édouard" },
      { code: "QC", nameEn: "Quebec", nameFr: "Québec" },
      { code: "SK", nameEn: "Saskatchewan", nameFr: "Saskatchewan" },
      { code: "YT", nameEn: "Yukon", nameFr: "Yukon" },
    ]

    this.currentLang = this.i18nService.getCurrentLang();
    if (this.currentLang == "en") {
      this.lang = true;
    }
    if (this.currentLang == "fr") { this.lang = false }
    /**
     * Check if this screen is for primary or co-applicant and set the progress percentage
     */
    this.preQualObj = this.util.getSessionStorage();
    this.isCoapplicantApplied = this.preQualObj.is_coapplicant_applied == 'Y' ? true : false;
    this.isExistingCustomer = this.preQualObj.is_existing_bankcustomers == 'Y' ? true : false;
    this.areBothCibcCustomer = this.preQualObj.are_both_applicants_CIBC_customer == 'Y' ? true : false;
    let progressPercent1 = sessionStorage.getItem("progressPercentage");
    this.util.isSidebarVisible.next(true);
    this.enumData = this.util.getEnumData();
    this._activatedRoute.url.subscribe(route => {
      this.currentRoutePath = route[0].path;
    });

  }
  ngOnInit(): void {
    this.valueChanges();
    this.preQualObj.users.forEach(obj => {
      if (obj.main_application == 0) {
        this.applicantUserObj = obj;
      } else {
        this.coApplicantUserObj = obj;
      }
    })

    if (this.isIos) {
      if (sessionStorage.getItem("tempAddressSession")) {
        let details = JSON.parse(sessionStorage.getItem("tempAddressSession"));
        let aptNo = atob(sessionStorage.getItem("aptNo"));
        this.addressForm.controls.streetName.setValue(details.addressline1);
        this.addressForm.controls.apartment.setValue(aptNo);
        this.addressForm.controls.city.setValue(details.city);
        this.addressForm.controls.province.setValue(details.province);
        this.addressForm.controls.postalCode.setValue(details.postal_code);
      }
      if (sessionStorage.getItem("coapplicantTempAddressSession")) {
        let coapplicantDetails = JSON.parse(sessionStorage.getItem("coapplicantTempAddressSession"));
        let coapplicantAptNo = atob(sessionStorage.getItem("coapplicantAptNo"));
        this.coapplicantAddressForm.controls.streetName.setValue(coapplicantDetails.addressline1);
        this.coapplicantAddressForm.controls.apartment.setValue(coapplicantAptNo);
        this.coapplicantAddressForm.controls.city.setValue(coapplicantDetails.city);
        this.coapplicantAddressForm.controls.province.setValue(coapplicantDetails.province);
        this.coapplicantAddressForm.controls.postalCode.setValue(coapplicantDetails.postal_code);
      }
    }
    this.currentLang = sessionStorage.getItem("currLang")
    this.formUtiObj.InitValues();

    document.getElementById("sidebarTitle").focus();

    if (sessionStorage.getItem("routeBack") == "true") {
      if ((this.isCoapplicantApplied && !this.isExistingCustomer) || (!this.isCoapplicantApplied && !this.isExistingCustomer)) {
        let aptNo = atob(sessionStorage.getItem("aptNo"));
        this.addressForm.controls.streetName.setValue(this.applicantUserObj.addressline1);
        this.addressForm.controls.apartment.setValue(aptNo);
        this.addressForm.controls.city.setValue(this.applicantUserObj.city);
        this.addressForm.controls.province.setValue(this.applicantUserObj.province);
        this.addressForm.controls.postalCode.setValue(this.applicantUserObj.postal_code);
      }
      if ((this.isCoapplicantApplied && !this.isExistingCustomer) || (this.isCoapplicantApplied && this.isExistingCustomer)) {
        let coapplicantAptNo = atob(sessionStorage.getItem("coapplicantAptNo"));
        this.coapplicantAddressForm.controls.streetName.setValue(this.coApplicantUserObj.addressline1);
        this.coapplicantAddressForm.controls.apartment.setValue(coapplicantAptNo);
        this.coapplicantAddressForm.controls.city.setValue(this.coApplicantUserObj.city);
        this.coapplicantAddressForm.controls.province.setValue(this.coApplicantUserObj.province);
        this.coapplicantAddressForm.controls.postalCode.setValue(this.coApplicantUserObj.postal_code);
      }
    }

  }
  valueChanges() {
    this.addressForm.get('apartment')?.valueChanges.subscribe(obj => {
      if (obj != '' && this.submitted) {
        this.apartmentApp = false;
      }
      if (this.submitted && (this.responseAddress?.applicant?.status == CONSTANTS.applicationConstants.addressApartmentMiss && this.checkBoxValue)) {
        this.onCheckBoxIsClicked(false);
      }
    })
    this.coapplicantAddressForm.get('apartment')?.valueChanges.subscribe(obj => {
      if (obj != '' && this.submitted) {
        this.apartmentCoapp = false;
      }

    })

  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (!this.isCoapplicantApplied || !this.isExistingCustomer) {
        this.address1Field = document.getElementById("streetName") as HTMLInputElement
        this.address1Field?.addEventListener('focus', () => {
          if (!this.autocompleteInitailise) {
            this.initAutocomplete();
            this.autocompleteInitailise = true;
          }
        })
      }
      if (this.isCoapplicantApplied || this.isExistingCustomer) {
        this.coapplicantAddress1Field = document.getElementById("coApplicantStreetName") as HTMLInputElement//document.querySelector("#autocomplete") as HTMLInputElement;
        this.coapplicantAddress1Field?.addEventListener('focus', () => {
          if (!this.autocompleteInitailiseCoapplicant)
            this.initAutocomplete();
          this.autocompleteInitailiseCoapplicant = true;
        })
      }

    });
  }
  get f() {
    return this.addressForm.controls;
  }
  get cf() {
    return this.coapplicantAddressForm.controls;
  }

  initAutocomplete() {
    if (!this.isCoapplicantApplied || !this.isExistingCustomer) {
      this.address1Field = document.getElementById("streetName") as HTMLInputElement//document.querySelector("#autocomplete") as HTMLInputElement;
      this.address2Field = document.querySelector("#address2") as HTMLInputElement;
      this.postalField = document.querySelector("#postcode") as HTMLInputElement;
      const self = this;
      if (this.autocomplete) {
        google.maps.event.clearInstanceListeners(this.autocomplete);
      }
      this.autocomplete = new google.maps.places.Autocomplete(this.address1Field, {
        componentRestrictions: { country: ["ca"] },
        fields: ["address_components", "geometry"],
      });

      setTimeout(() => {
        this.address1Field.setAttribute('autocomplete', 'address-line1');
      });
      // When the user selects an address from the drop-down, populate the
      // address fields in the form.
      this.autocomplete.addListener('place_changed', () => {
        if (this.autocomplete.getPlace()) {
          this.fillInAddress(this.autocomplete.getPlace());
        }
      });

    }

    if (this.isCoapplicantApplied || this.isExistingCustomer) {
      this.coapplicantAddress1Field = document.getElementById("coApplicantStreetName") as HTMLInputElement//document.querySelector("#autocomplete") as HTMLInputElement;
      this.coapplicantAddress2Field = document.querySelector("#coApplicantAddress2") as HTMLInputElement;
      this.coapplicantPostalField = document.querySelector("#coApplicantPostcode") as HTMLInputElement;
      // const self = this;
      this.coapplicantAutocomplete = new google.maps.places.Autocomplete(this.coapplicantAddress1Field, {
        componentRestrictions: { country: ["ca"] },
        fields: ["address_components", "geometry"],
      });
      setTimeout(() => {
        this.coapplicantAddress1Field.setAttribute('autocomplete', 'address-line1');
      });

      // When the coapplicant user selects an address from the drop-down, populate the
      // address fields in the form.
      this.coapplicantAutocomplete.addListener('place_changed', () => {
        this.coapplicantFillInAddress(this.coapplicantAutocomplete.getPlace());
      });
    }
  }


  fillInAddress(place) {
    // Get the place details from the autocomplete object.

    let address1 = "";
    let postcode = "";

    // Get each component of the address from the place details,
    // and then fill-in the corresponding field on the form.
    // place.address_components are google.maps.GeocoderAddressComponent objects
    // which are documented at http://goo.gle/3l5i5Mr
    for (const component of place.address_components as google.maps.GeocoderAddressComponent[]) {
      // @ts-ignore remove once typings fixed
      const componentType = component.types[0];
      switch (componentType) {
        case "street_number": {
          address1 = `${component.long_name} ${address1}`;
          break;
        }

        case "route": {
          address1 += component.short_name;
          break;
        }

        case "postal_code": {
          postcode = `${component.long_name}${postcode}`;
          break;
        }

        case "postal_code_prefix": {

          postcode = `${postcode}${component.long_name}`;
          break;
        }

        case "locality": {

          (document.querySelector("#locality") as HTMLInputElement).value =
            component.long_name;

          this.addressForm.controls.city.setValue(component.long_name);
          if (this.addressForm.controls.city.value) {
            this.cityColor = false
          }

          break;
        }

        case "administrative_area_level_1": {
          for (var province of this.provinceOptions) {
            if (province.code == component.short_name) {

              (document.querySelector("#state") as HTMLInputElement).value =
                component.short_name;

              this.addressForm.controls.province.setValue(component.short_name);
              if (this.addressForm.controls.province.value) {
                this.provinceColor = false
              }
            }
          }
          break;
        }
      }
    }
    this.address1Field.value = address1;
    this.addressForm.controls.streetName.setValue(address1);
    if (postcode) {
      this.addressForm.controls.postalCode.setValue(postcode);
      this.selCode = true;
    }
    this.postalField.value = postcode;

    // After filling the form with address components from the Autocomplete
    // prediction, set cursor focus on the second address line to encourage
    // entry of subpremise information such as apartment, unit, or floor number.

    this.address2Field.focus();
  }

  coapplicantFillInAddress(place) {
    // Get the place details from the autocomplete object.

    let address1 = "";
    let postcode = "";

    // Get each component of the address from the place details,
    // and then fill-in the corresponding field on the form.
    // place.address_components are google.maps.GeocoderAddressComponent objects
    // which are documented at http://goo.gle/3l5i5Mr
    for (const component of place.address_components as google.maps.GeocoderAddressComponent[]) {
      // @ts-ignore remove once typings fixed
      const componentType = component.types[0];
      switch (componentType) {
        case "street_number": {
          address1 = `${component.long_name} ${address1}`;
          break;
        }

        case "route": {
          address1 += component.short_name;
          break;
        }

        case "postal_code": {
          postcode = `${component.long_name}${postcode}`;
          break;
        }

        case "postal_code_prefix": {

          postcode = `${postcode}${component.long_name}`;
          break;
        }

        case "locality": {

          (document.querySelector("#coApplicantLocality") as HTMLInputElement).value =
            component.long_name;

          this.coapplicantAddressForm.controls.city.setValue(component.long_name);
          if (this.coapplicantAddressForm.controls.city.value) {
            this.cityColor = false
          }

          break;
        }

        case "administrative_area_level_1": {
          for (var province of this.provinceOptions) {
            if (province.code == component.short_name) {

              (document.querySelector("#coApplicantState") as HTMLInputElement).value =
                component.short_name;

              this.coapplicantAddressForm.controls.province.setValue(component.short_name);
              if (this.coapplicantAddressForm.controls.province.value) {
                this.provinceColor = false
              }
            }
          }
          break;
        }
      }
    }
    this.coapplicantAddress1Field.value = address1;
    this.coapplicantAddressForm.controls.streetName.value = address1
    if (postcode) {
      this.coapplicantAddressForm.controls.postalCode.setValue(postcode);
      this.coapplicantSelCode = true;
    }
    this.coapplicantPostalField.value = postcode;

    // After filling the form with address components from the Autocomplete
    // prediction, set cursor focus on the second address line to encourage
    // entry of subpremise information such as apartment, unit, or floor number.

    this.coapplicantAddress2Field.focus();
  }



  validatePostalCode(event) {
    this.selCode = false;
    this.coapplicantSelCode = false;
    let postcode: string = this.addressForm.value.postalCode;

    // Starts

    if (postcode.length > 6) {
      if (postcode.includes(' ') && postcode.length >= 7) {
        this.addressForm.controls.postalCode.setValue(postcode.substring(0, 7))
      } else {
        this.addressForm.controls.postalCode.setValue(postcode.substring(0, 6))
      }
    }

    if (event.keyCode === 32 && postcode.length !== 4) {
      this.addressForm.controls.postalCode.setValue(postcode.split(' ').join(''));
      if (postcode.length > 4 && postcode.split(' ').join('').length === 3) {
        this.addressForm.controls.postalCode.setValue(postcode.split(' ').join('') + ' ');
      }
    }

    let testCode: string = postcode.split(' ').join('');
    if (this.codeCheck(event, testCode) === false) {
      this.addressForm.controls.postalCode.setValue(testCode.slice(0, -1));
      this.colorPostal = true;
    } else {
      this.colorPostal = false;
    }
  }

  codeCheck(event, testCode) {
    if (event.key === '!' || event.key === '@' || event.key === '#' || event.key === '$' || event.key === '%' || event.key === '^' || event.key === '&' || event.key === '*' || event.key === '(' || event.key === ')') return false;
    else if (testCode.includes(' ')) {
      if ((testCode.length === 1 || testCode.length === 3 || testCode.length === 6) && ((event.keyCode > 95 && event.keyCode < 106) || (event.keyCode > 47 && event.keyCode < 58) || event.keyCode === 110 || event.keyCode === 111 || event.keyCode === 106 || event.keyCode === 107 || event.keyCode === 109 || event.keyCode === 192 || event.keyCode === 187 || event.keyCode === 189 || event.keyCode === 220 || event.keyCode === 188 || event.keyCode === 190 || event.keyCode === 191 || event.keyCode === 186 || event.keyCode === 110 || event.keyCode === 222 || event.keyCode === 219 || event.keyCode === 221)) return false;
      if ((testCode.length === 2 || testCode.length === 5 || testCode.length === 7) && ((event.keyCode > 64 && event.keyCode < 91) || event.keyCode === 110 || event.keyCode === 111 || event.keyCode === 106 || event.keyCode === 107 || event.keyCode === 109 || event.keyCode === 192 || event.keyCode === 187 || event.keyCode === 189 || event.keyCode === 220 || event.keyCode === 188 || event.keyCode === 190 || event.keyCode === 191 || event.keyCode === 186 || event.keyCode === 110 || event.keyCode === 222 || event.keyCode === 219 || event.keyCode === 221)) return false;
    } else {
      if ((testCode.length === 1 || testCode.length === 3 || testCode.length === 5) && ((event.keyCode > 95 && event.keyCode < 106) || (event.keyCode > 47 && event.keyCode < 58) || event.keyCode === 110 || event.keyCode === 111 || event.keyCode === 106 || event.keyCode === 107 || event.keyCode === 109 || event.keyCode === 192 || event.keyCode === 187 || event.keyCode === 189 || event.keyCode === 220 || event.keyCode === 188 || event.keyCode === 190 || event.keyCode === 191 || event.keyCode === 186 || event.keyCode === 110 || event.keyCode === 222 || event.keyCode === 219 || event.keyCode === 221)) return false;
      if ((testCode.length === 2 || testCode.length === 4 || testCode.length === 6) && ((event.keyCode > 64 && event.keyCode < 91) || event.keyCode === 110 || event.keyCode === 111 || event.keyCode === 106 || event.keyCode === 107 || event.keyCode === 109 || event.keyCode === 192 || event.keyCode === 187 || event.keyCode === 189 || event.keyCode === 220 || event.keyCode === 188 || event.keyCode === 190 || event.keyCode === 191 || event.keyCode === 186 || event.keyCode === 110 || event.keyCode === 222 || event.keyCode === 219 || event.keyCode === 221)) return false;
    }
    return true;
  }

  checkPostal(postal) {
    var regex = new RegExp(/^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i);
    if (regex.test(postal.value))
      return true;
    else return false;
  }

  tempAddressSession() {
    sessionStorage.setItem("aptNo", btoa(this.addressForm.value.apartment));
    let applicantAddressObj = {
      city: this.addressForm.value.city,
      province: this.addressForm.value.province,
      addressline1: this.addressForm.value.streetName,
      postal_code: this.addressForm.value.postalCode,
    }
    if (applicantAddressObj.postal_code.trim().indexOf(" ") == -1) {
      applicantAddressObj.postal_code = applicantAddressObj.postal_code.trim().substring(0, 3) + " " + applicantAddressObj.postal_code.trim().substring(3, 6)
    }
    if (this.isIos) {
      sessionStorage.setItem("tempAddressSession", JSON.stringify(applicantAddressObj));
    }
  }

  coapplicantTempAddressSession() {
    sessionStorage.setItem("coapplicantAptNo", btoa(this.coapplicantAddressForm.value.apartment));
    let coapplicantAddressObj = {
      city: this.coapplicantAddressForm.value.city,//this.addressForm.value.city;,
      province: this.coapplicantAddressForm.value.province,
      addressline1: this.coapplicantAddressForm.value.streetName,
      postal_code: this.coapplicantAddressForm.value.postalCode,
    }
    if (coapplicantAddressObj.postal_code.trim().indexOf(" ") == -1) {
      coapplicantAddressObj.postal_code = coapplicantAddressObj.postal_code.trim().substring(0, 3) + " " + coapplicantAddressObj.postal_code.trim().substring(3, 6)
    }
    if (this.isIos) {
      sessionStorage.setItem("coapplicantTempAddressSession", JSON.stringify(coapplicantAddressObj));
    }
  }

  onContinue() {
    this.apartmentApp = false;
    this.apartmentCoapp = false;
    this.submitted = true;
    this.coSubmitted = true;
    let f = this.addressForm.controls;
    let cf = this.coapplicantAddressForm.controls;

    if (this.isIos) {
      sessionStorage.removeItem("tempAddressSession");
      sessionStorage.removeItem("coapplicantTempAddressSession");
    }

    if (f.streetName.value) {
      this.streetColor = false
    }
    if (f.city.value) {
      if (f.city.errors) {
        f.city.errors.required = false;
      }
      this.cityColor = false
    }
    if (f.province.value) {
      if (f.province.errors) {
        f.province.errors.required = false
      }
      this.provinceColor = false
    }
    if (f.postalCode.value) {
      this.postalColor = false
    }


    if (cf.streetName.value) {
      this.coapplicantStreetColor = false
    }
    if (cf.city.value) {
      if (cf.city.errors) {
        cf.city.errors.required = false;
      }
      this.coapplicantCityColor = false
    }
    if (cf.province.value) {
      if (cf.province.errors) {
        cf.province.errors.required = false
      }
      this.coapplicantProvinceColor = false
    }
    if (cf.postalCode.value) {
      this.coapplicantPostalColor = false
    }
    if (this.preQualObj.flow_type == this.switchType) {
      var errorArray = [];
      if ((this.preQualObj.is_coapplicant_applied == 'Y' || this.preQualObj.is_coapplicant_applied == 'N') && this.preQualObj.users[0].is_existing_bankcustomer != 'Y') {
        for (const key in f) {
          if (f[key].errors && f[key]) {
            var msgType = {
              type: (f[key].value != "") ? "" : "missing",
              field: key,
              subtype: "",
              code: ""
            }
            errorArray.push(msgType);

          }
        }
      }
      if (this.preQualObj.is_coapplicant_applied == 'Y' && this.preQualObj.users[1].is_existing_bankcustomer != 'Y') {
        for (const key in cf) {
          if (f[key].errors && f[key]) {
            var msgType = {
              type: (f[key].value != "") ? "" : "missing",
              field: key,
              subtype: "",
              code: ""
            }
            errorArray.push(msgType);
          }
        }
      }
      if (errorArray.length > 0) {
        this.util.adobeAnalyticalErrorMsg('', '', '', errorArray);
      }
    }

    const isApplicantValid = !f.streetName.errors?.invalidStreet &&
      !f.apartment.errors?.invalidApartment && !f.city.errors?.invalidCity &&
      !f.postalCode.errors?.pattern && !this.streetColor &&
      !this.cityColor && !this.provinceColor && !this.postalColor && !this.apartmentApp

    const isCoApplicantValid = !cf.streetName.errors?.invalidStreet &&
      !cf.apartment.errors?.invalidApartment && !cf.city.errors?.invalidCity &&
      !cf.postalCode.errors?.pattern && !this.coapplicantStreetColor &&
      !this.coapplicantCityColor && !this.coapplicantProvinceColor && !this.coapplicantPostalColor && !this.apartmentCoapp

    const isFormValid = (this.isCoapplicantApplied && !this.isExistingCustomer)
      ? (isApplicantValid && isCoApplicantValid)
      : (!this.isCoapplicantApplied ? isApplicantValid : isCoApplicantValid);


    if (isFormValid) {
      this.loader = true;

      let sessionObj = this.util.getSessionStorage();

      if (!this.isCoapplicantApplied || !this.isExistingCustomer) {
        this.applicantUserObj.city = f.city.value;
        this.applicantUserObj.province = this.addressForm.value.province;
        this.applicantUserObj.addressline1 = (this.addressForm.value.apartment!='') ? this.addressForm.value.apartment + "-" + this.addressForm.value.streetName : this.addressForm.value.streetName;
        this.applicantUserObj.addressline1 = this.applicantUserObj.addressline1.trim();
        this.applicantUserObj.postal_code = this.addressForm.value.postalCode;
        if (this.applicantUserObj.postal_code.trim().indexOf(" ") == -1) {
          this.applicantUserObj.postal_code = this.applicantUserObj.postal_code.trim().substring(0, 3) + " " + this.applicantUserObj.postal_code.trim().substring(3, 6)
        }
      }
      if (this.isCoapplicantApplied || this.isExistingCustomer) {
        this.coApplicantUserObj.city = cf.city.value;
        this.coApplicantUserObj.province = this.coapplicantAddressForm.value.province;
        this.coApplicantUserObj.addressline1 = (this.coapplicantAddressForm.value.apartment!='') ? this.coapplicantAddressForm.value.apartment + "-" + this.coapplicantAddressForm.value.streetName : this.coapplicantAddressForm.value.streetName;
        this.coApplicantUserObj.postal_code = this.coapplicantAddressForm.value.postalCode;
        if (this.coApplicantUserObj.postal_code.trim().indexOf(" ") == -1) {
          this.coApplicantUserObj.postal_code = this.coApplicantUserObj.postal_code.trim().substring(0, 3) + " " + this.coApplicantUserObj.postal_code.trim().substring(3, 6)
        }
      }

      sessionObj.users.forEach((user, index) => {
        if (user.main_application == 0) {
          sessionObj.users[index] = this.applicantUserObj;
        } else {
          sessionObj.users[index] = this.coApplicantUserObj;
        }
      })

      if (!this.isCoapplicantApplied || !this.isExistingCustomer) {
        sessionStorage.setItem("aptNo", btoa(this.addressForm.value.apartment));
      }
      if (this.isCoapplicantApplied || this.isExistingCustomer) {
        sessionStorage.setItem("coapplicantAptNo", btoa(this.coapplicantAddressForm.value.apartment));
      }

      this.util.setSessionStorage(sessionObj);

      sessionStorage.setItem("progressPercentage", String(this.nextProgressPercent));
      if (sessionStorage.getItem("routeBack") == "true") {
        this.router.navigate(['../personal-information-preview'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
      }
      else {
        if (this.checkBoxValue) {
          sessionObj.users.splice(1, 1);
        }
        this.util.demoGetEcifResponse(sessionObj).subscribe((res) => {
          this.loader = false;
          this.responseAddress = res;

          if (this.responseAddress?.applicant) {
            this.responseAddress.applicant.status = Number(this.responseAddress?.applicant?.status);
            if (this.responseAddress.applicant?.cleansedAddrss?.postalRural != undefined || this.responseAddress.applicant?.cleansedAddrss?.postalRural != null) {
              this.preQualObj.users[0]['postalRural'] = this.responseAddress.applicant.cleansedAddrss.postalRural;
              if (this.checkBoxValue) {
                this.preQualObj.users[1]['postalRural'] = this.responseAddress.applicant.cleansedAddrss.postalRural;
            }
            }
            
          }
          if (this.responseAddress?.coapplicant) {
            this.responseAddress.coapplicant.status = Number(this.responseAddress?.coapplicant?.status);
            if (this.responseAddress.coapplicant?.cleansedAddrss?.postalRural != undefined || this.responseAddress.coapplicant?.cleansedAddrss?.postalRural != null) {
              this.preQualObj.users[1]['postalRural'] = this.responseAddress.coapplicant.cleansedAddrss.postalRural;
            }
          }

          this.apartmentApp = (this.responseAddress?.applicant?.status == CONSTANTS.applicationConstants.addressApartmentMiss) ? true : false;
          if (this.preQualObj.flow_type == this.switchType) {
            if (this.apartmentApp) {
              var errorArray = [];
              var msgType = {
                type: "missing",
                field: "apartment",
                subtype: "",
                code: String(this.responseAddress?.applicant?.status)
              }
              errorArray.push(msgType);
              this.util.adobeAnalyticalErrorMsg('', '', '', errorArray);
            }
          }
          this.apartmentCoapp = (this.responseAddress?.coapplicant?.status == CONSTANTS.applicationConstants.addressApartmentMiss) ? true : false;
          if (Object.keys(this.responseAddress).length == 0) {
            this.invalidCount++;
            this.invalidAddressApplicant = true;
            this.invalidAddressCoapplicant = true;
            if (this.invalidCount == 3) {
              this.router.navigate(['../request-callback'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
            }
          }
          else {
            this.addressSuggestionResponse = { ...this.responseAddress };
            if (this.isCoapplicantApplied && !this.isExistingCustomer) {
              if (this.checkBoxValue) {
                this.responseAddress["coapplicant"] = this.responseAddress.applicant;
                delete this.addressSuggestionResponse.coapplicant;
              }
              if (this.responseAddress.applicant.status != null || this.responseAddress.coapplicant.status != null) {
                if ((this.responseAddress?.applicant?.status == CONSTANTS.applicationConstants.addressSuccess) && (this.responseAddress?.coapplicant?.status == CONSTANTS.applicationConstants.addressSuccess)) {
                  this.preQualObj.users[0]['address_api_certificate'] = this.responseAddress.applicant.addressAPICertificate;
                  this.preQualObj.users[1]['address_api_certificate'] = this.responseAddress.coapplicant.addressAPICertificate;
                  this.invalidAddressApplicant = false;
                  this.invalidAddressCoapplicant = false;
                  this.router.navigate(['../personal-information-contact'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
                }
                else if (this.responseAddress?.applicant?.status == CONSTANTS.applicationConstants.addressSuccess || this.responseAddress?.coapplicant?.status == CONSTANTS.applicationConstants.addressSuccess) {
                  var deleteExactMatchUser = null;
                  if (this.responseAddress?.applicant?.status == CONSTANTS.applicationConstants.addressSuccess) {
                    this.preQualObj.users[0]['address_api_certificate'] = this.responseAddress.applicant.addressAPICertificate;
                    deleteExactMatchUser = 0;
                  }
                  else {
                    if (this.responseAddress?.applicant?.status != CONSTANTS.applicationConstants.addressApartmentMiss && this.responseAddress?.applicant?.status >= CONSTANTS.applicationConstants.addressPartialMatch_1 && this.responseAddress?.applicant?.status <= CONSTANTS.applicationConstants.addressPartialMatch_2) {
                      this.addressSuggestionResponse.applicant["main_application"] = 0;
                      this.showAddressPopup = true;
                    }
                    else {
                      this.invalidCount++;
                      this.invalidAddressApplicant = true;
                      if (this.preQualObj.flow_type == this.switchType) {
                        this.util.adobeAnalyticalErrorMsg("streetname", "invalid-streetname", this.responseAddress?.applicant?.status, null);

                      }
                      if (this.invalidCount == 3) {
                        this.router.navigate(['../request-callback'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
                      }
                    }
                  }

                  if (this.responseAddress?.coapplicant?.status == CONSTANTS.applicationConstants.addressSuccess) {
                    this.preQualObj.users[1]['address_api_certificate'] = this.responseAddress.coapplicant.addressAPICertificate;
                    deleteExactMatchUser = 1;
                  }
                  else {
                    if (this.responseAddress?.coapplicant?.status != CONSTANTS.applicationConstants.addressApartmentMiss && this.responseAddress?.coapplicant?.status >= CONSTANTS.applicationConstants.addressPartialMatch_1 && this.responseAddress?.coapplicant?.status <= CONSTANTS.applicationConstants.addressPartialMatch_2) {
                      this.addressSuggestionResponse.coapplicant["main_application"] = 1;
                      this.showAddressPopup = true;
                    }
                    else {
                      if (this.preQualObj.flow_type == this.switchType) {
                        this.util.adobeAnalyticalErrorMsg("streetname", "invalid-streetname", this.responseAddress?.coapplicant?.status, null);
                      }
                      this.invalidCount++;
                      this.invalidAddressCoapplicant = true;
                      if (this.invalidCount == 3) {
                        this.router.navigate(['../request-callback'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
                      }
                    }
                  }

                  if (deleteExactMatchUser != null) {
                    if (deleteExactMatchUser == 0) delete this.addressSuggestionResponse.applicant;
                    else delete this.addressSuggestionResponse.coapplicant;
                  }
                }
                else {

                  if ((this.partialStatus.includes(this.responseAddress?.applicant?.status) && this.partialStatus.includes(this.responseAddress?.coapplicant?.status)) && ((this.responseAddress?.applicant?.status != CONSTANTS.applicationConstants.addressApartmentMiss && this.responseAddress?.applicant?.status >= CONSTANTS.applicationConstants.addressPartialMatch_1 && this.responseAddress?.applicant?.status <= CONSTANTS.applicationConstants.addressPartialMatch_2) || (this.responseAddress?.coapplicant?.status != CONSTANTS.applicationConstants.addressApartmentMiss && this.responseAddress.coapplicant.status >= CONSTANTS.applicationConstants.addressPartialMatch_1 && this.responseAddress.coapplicant.status <= CONSTANTS.applicationConstants.addressPartialMatch_2))) {
                    this.addressSuggestionResponse.applicant["main_application"] = 0;
                    if (!this.checkBoxValue)
                      this.addressSuggestionResponse.coapplicant["main_application"] = 1;
                    this.showAddressPopup = true;
                  }
                  else {
                    this.invalidCount++;
                    if (!this.partialStatus.includes(this.responseAddress?.applicant?.status) && this.responseAddress?.applicant?.status != CONSTANTS.applicationConstants.addressApartmentMiss)
                      this.invalidAddressApplicant = true;
                    if (!this.partialStatus.includes(this.responseAddress.coapplicant.status) && this.responseAddress?.coapplicant?.status != CONSTANTS.applicationConstants.addressApartmentMiss)
                      this.invalidAddressCoapplicant = true;
                    if (this.invalidCount == 3) {
                      this.router.navigate(['../request-callback'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
                    }
                  }
                }
              }
              else {
                this.router.navigate(['../request-callback'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
              }
            }
            else {
              if (this.responseAddress?.applicant?.status == CONSTANTS.applicationConstants.addressSuccess || this.responseAddress?.coapplicant?.status == CONSTANTS.applicationConstants.addressSuccess) {
                if (!this.isCoapplicantApplied) {
                  this.preQualObj.users[0]['address_api_certificate'] = this.responseAddress.applicant.addressAPICertificate;
                  this.util.setSessionStorage(this.preQualObj);
                }
                if (this.isCoapplicantApplied) {
                  this.preQualObj.users[1]['address_api_certificate'] = this.responseAddress.coapplicant.addressAPICertificate;
                }
                this.invalidAddressApplicant = false;
                this.router.navigate(['../personal-information-contact'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });

              }
              else {
                if (!this.isCoapplicantApplied || !this.isExistingCustomer) {
                  if (this.responseAddress?.applicant?.status != CONSTANTS.applicationConstants.addressApartmentMiss && this.responseAddress?.applicant?.status >= 39602 && this.responseAddress?.applicant?.status <= 39608) {
                    this.addressSuggestionResponse.applicant["main_application"] = 0;
                    this.showAddressPopup = true;
                  }
                  else {
                    if (this.preQualObj.flow_type == this.switchType) {
                      this.util.adobeAnalyticalErrorMsg("streetname", "invalid-streetname", this.responseAddress?.applicant?.status, null);
                    }
                    this.invalidCount++;
                    this.invalidAddressApplicant = true;

                    if (this.invalidCount == 3) {
                      this.router.navigate(['../request-callback'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
                    }
                  }
                }
                if (this.isCoapplicantApplied || this.isExistingCustomer) {
                  if (this.responseAddress?.coapplicant?.status != CONSTANTS.applicationConstants.addressApartmentMiss && this.responseAddress?.coapplicant?.status >= 39602 && this.responseAddress?.coapplicant?.status <= 39608) {
                    this.addressSuggestionResponse.coapplicant["main_application"] = 1;
                    this.showAddressPopup = true;
                  }
                  else {
                    if (this.preQualObj.flow_type == this.switchType) {
                      this.util.adobeAnalyticalErrorMsg("streetname", "invalid-streetname", this.responseAddress?.coapplicant?.status, null);
                    }
                    this.invalidCount++;
                    this.invalidAddressCoapplicant = true;
                    if (this.invalidCount == 3) {
                      this.router.navigate(['../request-callback'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
                    }
                  }
                }
              }
            }
            this.util.setSessionStorage(this.preQualObj);
          }
          if (this.invalidAddressApplicant) {
            if (this.invalidCount < 3 && this.responseAddress?.applicant?.status != CONSTANTS.applicationConstants.addressApartmentMiss) {
              this.addressForm.get('streetName')?.setErrors({ noMatchFound: true });
              this.addressForm.get('streetName')?.markAsTouched();
            }
          }
          if (this.invalidAddressCoapplicant) {
            if (this.invalidCount < 3 && this.responseAddress?.coapplicant?.status != CONSTANTS.applicationConstants.addressApartmentMiss) {
              if (!this.checkBoxValue)
                this.coapplicantAddressForm.get('streetName')?.setErrors({ noMatchFound: true });
              this.coapplicantAddressForm.get('streetName')?.markAsTouched();
            }
          }
          for (const key of Object.keys(this.addressForm.controls)) {
            if (this.addressForm.controls[key].invalid) {
              const invalidControl = this.el.nativeElement.querySelector('[formcontrolname="' + key + '"]');
              if (key == 'streetName') {
                invalidControl.blur();
              }
              else {
                invalidControl.focus();
              }
              break;
            }
          }
          if (this.isCoapplicantApplied) {
            for (const key of Object.keys(this.coapplicantAddressForm.controls)) {
              if (this.coapplicantAddressForm.controls[key].invalid) {
                const invalidControl = this.el.nativeElement.querySelector('[formcontrolname="' + key + '"]');
                if (key == 'streetName') {
                  invalidControl.blur();
                }
                else {
                  invalidControl.focus();
                }
                break;
              }
            }
          }
          if (this.showAddressPopup) {
            $("#addressPop").modal('show');
          }

        }, (error) => {
          this.router.navigate(['../request-callback'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
        });


      }
    }
    else {
      this.invalidCount++;
      if (this.invalidCount == 3) {
        this.router.navigate(['../request-callback'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
      }
    }







  }

  onCheckBoxIsClicked(incomingValue: boolean) {

    this.checkBoxValue = incomingValue;
    if (this.checkBoxValue) {

      this.coapplicantAddressForm.setValue({
        streetName: this.addressForm.get('streetName')?.value,
        apartment: this.addressForm.get('apartment')?.value,
        city: this.addressForm.get('city')?.value,
        province: this.addressForm.get('province')?.value,
        postalCode: this.addressForm.get('postalCode')?.value
      })

      this.coapplicantAddressForm.disable();


    } else {
      this.coapplicantAddressForm.enable();

      Object.keys(this.coapplicantAddressForm.controls).forEach(field => {
        this.coapplicantAddressForm.get(field)?.setValue('');
      })

    }
  }

  receivedAddress(addressArray: any) {
    this.dismiss();
    const addressFields = ['street', 'city', 'province', 'postalCode'];
    this.showAddressPopup = false;
    if (this.checkBoxValue) {
      var newArray = Array.from({ length: 2 }, () => ({ ...addressArray[0] }));
      newArray[1].main_application = 1;
    }
    else {
      newArray = [...addressArray];
    }
    newArray.forEach(item => {
      if (item.main_application != null) {
        const splitAddress = item.selectedAddress.split(',').map(val => val.trim());

        let populatedAddressObj = {};
        for (let i = 0; i < addressFields.length; i++) {
          populatedAddressObj[addressFields[i]] = splitAddress[i] || '';
        }

        this.preQualObj.users[item.main_application].addressline1 = populatedAddressObj["street"];
        this.preQualObj.users[item.main_application].city = populatedAddressObj["city"];
        this.preQualObj.users[item.main_application].province = populatedAddressObj["province"];
        this.preQualObj.users[item.main_application].postal_code = populatedAddressObj["postalCode"];

        this.preQualObj.users[item.main_application]["address_api_certificate"] = item.addressCertificate;
      }

    });


    this.util.setSessionStorage(this.preQualObj);
    this.router.navigate(['../personal-information-contact'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
  }
  dismiss() {
    $("#addressPop").modal('hide');
  }


}



